export var D365F_AUTOCOMPLETE_OPTIONS;
(function (D365F_AUTOCOMPLETE_OPTIONS) {
    D365F_AUTOCOMPLETE_OPTIONS["LEGAL_ENTITY"] = "legalEntity";
    D365F_AUTOCOMPLETE_OPTIONS["MAIN_ACCOUNT"] = "mainAccount";
    D365F_AUTOCOMPLETE_OPTIONS["BUSINESS_UNIT"] = "businessUnit";
    D365F_AUTOCOMPLETE_OPTIONS["DEPARTMENT"] = "department";
    D365F_AUTOCOMPLETE_OPTIONS["SUB_DEPARTMENT"] = "subDepartment";
    D365F_AUTOCOMPLETE_OPTIONS["CUSTOMER"] = "customer";
    D365F_AUTOCOMPLETE_OPTIONS["SITE"] = "site";
})(D365F_AUTOCOMPLETE_OPTIONS || (D365F_AUTOCOMPLETE_OPTIONS = {}));
//# sourceMappingURL=d365f.js.map